import React from 'react';
import styled from 'styled-components';
import { publicImageUrl } from '../../../lib/publicImageUrl';
import { floating } from '../../../../shared/lib/styles';
import Image from '../../../../shared/components/Image';

const StyledSupportPerson = styled.div`
    position: relative;
    width: 232px;
    padding-bottom: 60px;
`;

const PersonWrapper = styled.div`
    position: relative;
    z-index: 2;
    width: 100%;
    height: auto;
    animation: 2s infinite alternate ${floating};
`;

const ShadowWrapper = styled.div`
    position: absolute;
    z-index: 2;
    width: 100%;
    height: auto;
    bottom: 0;
`;

const SupportPerson = () => (
    <StyledSupportPerson>
        <PersonWrapper>
            <Image
                src={publicImageUrl('support/joe.png')}
                alt={__('support person on phone')}
                width={224}
                height={328}
                data-testid="support-person"
            />
        </PersonWrapper>
        <ShadowWrapper>
            <Image src={publicImageUrl('support/shadow.png')} width={232} height={97} alt="" />
        </ShadowWrapper>
    </StyledSupportPerson>
);

export default SupportPerson;
